/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/**  The Account type describes an account registered in the Backup. */
export type Account = {
  __typename?: "Account";
  /**  Determines the cloud provider in which the account is created. */
  cloudProvider: CloudProvider;
  /**  A cloud provider id, e.g. in case of AWS this is the account number, in case of Azure, subscription id. */
  cloudProviderId: Scalars["String"];
  /**  Internal identifier of the account. */
  id: Scalars["String"];
  /**  A primary name of the account. */
  name: Scalars["String"];
  /**  Determines if it's a VAULT or PROTECTED account. */
  type: AccountType;
};

/**
 *  The AccountAccessRoleAws type contains URL to
 * IAM role definition which should be created in the user's AWS account.
 */
export type AccountAccessRoleAws = {
  __typename?: "AccountAccessRoleAws";
  /**  Identifier of the account to which the role belongs. */
  accountId: Scalars["String"];
};

export type AccountAwsAccessRoleTemplateInput = {
  /**   The account id (format: AWS__<customer_id>__<aws account id>) */
  accountId: Scalars["String"];
  /**   Account type, PROTECTED or VAULT */
  accountType: AccountType;
  customerId: Scalars["String"];
};

export type AccountAwsChinaAccessRoleTemplateInput = {
  accountId: Scalars["String"];
  accountType: AccountType;
  customerId: Scalars["String"];
  staticCredentials: StaticAwsCredentialsInput;
};

export type AccountAwsRoleInput = {
  /**   Arn of a role */
  arn: Scalars["String"];
  /**   External id of the role (optional) */
  externalId?: InputMaybe<Scalars["String"]>;
};

/**  The enumeration of supported accounts types. */
export enum AccountType {
  Protected = "PROTECTED",
  Vault = "VAULT",
}

export type AccountsPage = {
  __typename?: "AccountsPage";
  data: Array<Account>;
};

export type AccountsSearchCriteria = {
  /**   Account type to get (PROTECTED, VAULT) */
  accountType?: InputMaybe<AccountType>;
  /**   Customer ID */
  customerId: Scalars["String"];
};

export type ActivatingSetting = {
  __typename?: "ActivatingSetting";
  /**   A list of values which cause dependent setting to become activated (present on the form) */
  activatingValues: Array<Maybe<Scalars["String"]>>;
  /**   Identifier of a setting */
  id: Scalars["String"];
};

export type AddResourceInput = {
  /**  Account id from AutoBackup. */
  accountId: Scalars["String"];
  /**  Customer id from AutoBackup. */
  customerId: Scalars["String"];
  /**  Resource id from cloud provider e.g ARN in AWS. */
  id: Scalars["String"];
  /**  Region where resource is located. */
  region: Scalars["String"];
  sizeInBytes?: InputMaybe<Scalars["String"]>;
  tags?: InputMaybe<Array<Tag>>;
  /**  Resource type. */
  type: Scalars["String"];
};

export type AddUserInput = {
  email: Scalars["String"];
};

export type ApiKey = {
  __typename?: "ApiKey";
  alias: Scalars["String"];
  createdAt: Scalars["String"];
  createdBy: Scalars["String"];
  customerAccesses: CustomerAccessesPage;
  id: Scalars["ID"];
  lastUsedAt?: Maybe<Scalars["String"]>;
  owner: Scalars["String"];
};

export type ApiKeyCustomerAccessesArgs = {
  searchCriteria?: InputMaybe<ApiKeyCustomerAccessesSearchCriteria>;
};

export type ApiKeyCustomerAccessesSearchCriteria = {
  /**   If no customer ID is provided, all customer accesses will be returned. */
  customerId?: InputMaybe<Scalars["ID"]>;
  /**   If no page number is provided, the first one will be returned. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type ApiKeysPage = {
  __typename?: "ApiKeysPage";
  data: Array<ApiKey>;
  totalNumberOfApiKeys: Scalars["Int"];
  totalNumberOfPages: Scalars["Int"];
};

export type ApiKeysSearchCriteria = {
  /**   If provided, only keys owned by the `owner` will be returned. */
  owner?: InputMaybe<Scalars["String"]>;
  /**   If no page number is provided, the first one will be returned. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

/**  The AzureCredentialsInput contains required Azure credentials */
export type AzureCredentialsInput = {
  clientId: Scalars["String"];
  clientSecret: Scalars["String"];
  tenantId: Scalars["String"];
};

export type BackupEvent = {
  __typename?: "BackupEvent";
  id: Scalars["String"];
  /**   Number of resources backed up in */
  numberOfBackedUpResources: Scalars["Int"];
  /**   Name of backup plan */
  planName: Scalars["String"];
  /**   Progress of the event */
  progress: BackupEventProgress;
  /**   Start datetime of the event (UNIX timestamp) */
  startTimestamp: Scalars["Int"];
  /**   Status of the event */
  status: BackupEventStatus;
  /**   Total number of resources associated with backup event */
  totalNumberOfResources: Scalars["Int"];
  /**   Type */
  type: BackupEventType;
};

/**   Progress of the backup event */
export enum BackupEventProgress {
  Created = "CREATED",
  Finished = "FINISHED",
  InProgress = "IN_PROGRESS",
}

export type BackupEventResource = {
  __typename?: "BackupEventResource";
  failureReason?: Maybe<Scalars["String"]>;
  /**   Backup progress of the resource */
  progress: BackupEventProgress;
  replicaFailureReason?: Maybe<Scalars["String"]>;
  /**   Resource associated with the backup event */
  resource: Resource;
  snapshot?: Maybe<Snapshot>;
  snapshotReplica?: Maybe<Snapshot>;
  /**   Backup status of the resource */
  status?: Maybe<Scalars["String"]>;
};

export type BackupEventResourcesPage = {
  __typename?: "BackupEventResourcesPage";
  data: Array<BackupEventResource>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfResources: Scalars["Int"];
};

export type BackupEventResourcesSearchCriteria = {
  backupEventId: Scalars["String"];
  customerId: Scalars["String"];
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type BackupEventSearchCriteria = {
  customerId: Scalars["String"];
  eventId: Scalars["String"];
};

export type BackupEventStats = {
  __typename?: "BackupEventStats";
  numberOfBackedUpResources: Scalars["Int"];
  numberOfResourcesMeetingRPO: Scalars["Int"];
  successRateHistory: Array<SuccessRateHistoryEntry>;
  totalNumberOfResources: Scalars["Int"];
};

export type BackupEventStatsSearchCriteria = {
  backupEventId: Scalars["String"];
  customerId: Scalars["String"];
};

/**   Status of the backup event */
export enum BackupEventStatus {
  Failed = "FAILED",
  FailedStopped = "FAILED_STOPPED",
  PartiallyFailed = "PARTIALLY_FAILED",
  ReplicationFailed = "REPLICATION_FAILED",
  Success = "SUCCESS",
  Waiting = "WAITING",
}

export enum BackupEventType {
  OnDemand = "ON_DEMAND",
  Schedule = "SCHEDULE",
}

export type BackupEventsPage = {
  __typename?: "BackupEventsPage";
  data: Array<BackupEvent>;
  totalNumberOfEvents?: Maybe<Scalars["Int"]>;
  totalNumberOfPages: Scalars["Int"];
};

/**   BackupEventsSearchCriteria contains filters used for searching the backup events. */
export type BackupEventsSearchCriteria = {
  /**   Id of the customer for which the events will be returned. */
  customerId: Scalars["String"];
  /**   Filters used to search for backup events */
  filters: Array<FilterInput>;
  /**   The number of the selected page. First page is the default one and is used when this field is empty. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
  /**   The maximal number of events returned on single page. */
  pageSize?: InputMaybe<Scalars["Int"]>;
  /**   Optional filter indicating that only events with the provided backup progress should be returned (deprecated use filters). */
  progress?: InputMaybe<BackupEventProgress>;
  /**   The backup events order. Optional, if not provided default sorting order is descending order. */
  startTimeOrder?: InputMaybe<Order>;
  /**   Optional filter indicating that only events with the provided status should be returned (deprecated use filters). */
  status?: InputMaybe<BackupEventStatus>;
};

export type BackupPoliciesBoundary = {
  __typename?: "BackupPoliciesBoundary";
  /**  Max number of days for primary snapshot retention. */
  maxPrimarySnapshotRetentionInDays: Scalars["Int"];
  /**  Max number of retained primary snapshots. */
  maxPrimarySnapshotRetentionQuantity: Scalars["Int"];
  /**  Max number of days for replicated snapshot retention. */
  maxReplicaSnapshotRetentionInDays: Scalars["Int"];
  /**  Max number of retained replicated snapshots. */
  maxReplicaSnapshotRetentionQuantity: Scalars["Int"];
  /**  Minimal allowed RPO for the customer. */
  minRPOInHours: Scalars["Int"];
};

export type BackupPoliciesBoundaryInput = {
  maxPrimarySnapshotRetentionInDays: Scalars["Int"];
  maxPrimarySnapshotRetentionQuantity: Scalars["Int"];
  maxReplicaSnapshotRetentionInDays: Scalars["Int"];
  maxReplicaSnapshotRetentionQuantity: Scalars["Int"];
  minRPOInHours: Scalars["Int"];
};

/**  The BackupPolicy is a type representing an identifiable set of preconfigured RPO and retention settings. */
export type BackupPolicy = {
  __typename?: "BackupPolicy";
  /**  Identifier of the backup policy. */
  id: Scalars["String"];
  /**  User friendly name of the policy. */
  name: Scalars["String"];
  /**  Policy settings */
  policySettings?: Maybe<Array<PolicySettings>>;
  /**  RemovePrimarySnapshotsAfterResourceDeletion indicates that primary snapshots should be removed after resource deletion. */
  removePrimarySnapshotsAfterResourceDeletion: Scalars["Boolean"];
  /**  RemoveReplicaSnapshotsAfterResourceDeletion indicates that replica snapshots should be removed after resource deletion. */
  removeReplicaSnapshotsAfterResourceDeletion: Scalars["Boolean"];
  /**
   *  RPO and retention settings
   * @deprecated use policySettings field
   */
  settings?: Maybe<BackupPolicySettings>;
  /**   Friendly tag value */
  tagValue: Scalars["String"];
  /**  Policy time aware settings, required when type is set to TIME_AWARE. */
  timeAwarePolicySettings?: Maybe<TimeAwarePolicySettings>;
  /**  Type [RPO, TIME_AWARE], default RPO type. */
  type: PolicyType;
};

export type BackupPolicySearchCriteria = {
  /**   ID of backup policy to fetch. */
  backupPolicyId: Scalars["String"];
  /**   Identifier of customer of the backup policy. */
  customerId: Scalars["String"];
};

/**  The BackupPolicySettings type represents concrete RPO and retention settings which will be applied to backed up resources. */
export type BackupPolicySettings = {
  __typename?: "BackupPolicySettings";
  /**  Backups retention settings. */
  retention: SnapshotsRetention;
  /**  A desirable time interval between resource backups expressed in hours. */
  rpoInHours: Scalars["Int"];
};

export type BackupSetting = {
  __typename?: "BackupSetting";
  /**   Description of the setting */
  description: Scalars["String"];
  /**   ID of a backup setting */
  id: Scalars["String"];
  /**   Label of the setting */
  label: Scalars["String"];
  /**   User-friendly name */
  name: Scalars["String"];
  /**   Type of the value */
  type: BackupSettingType;
  /**   Value of the setting */
  value: Scalars["String"];
};

export type BackupSettingCandidate = {
  __typename?: "BackupSettingCandidate";
  /**
   *   Field deciding if the backup setting should be present on the backup setup creation form.
   *  If activatedBy is null, then the setting should always be present.
   *  Otherwise, the setting should be present on the form if and only if other backup setting described
   *  by ActivatingSetting type has appropriate value.
   *  Deprecated, use activatedBySettings
   */
  activatedBy?: Maybe<ActivatingSetting>;
  /**
   *   Field deciding if the backup setting should be present on the backup setup creation form.
   *  If activatedBySettings is empty, then the setting should always be present.
   *  Otherwise, the setting should be present on the form if and only if other backup settings described
   *  by ActivatingSetting type has appropriate value.
   */
  activatedBySettings?: Maybe<Array<ActivatingSetting>>;
  /**   Allowed list of values (optional) */
  allowedValues?: Maybe<Array<BackupSettingCandidateValue>>;
  /**   A flag indicating if field will be supported in the future. */
  deprecated: Scalars["Boolean"];
  /**   Description of the setting */
  description: Scalars["String"];
  /**   ID of a backup setting candidate */
  id: Scalars["String"];
  /**   A flag indicating if it is mandatory to provide a value for this backup setting. */
  isRequired: Scalars["Boolean"];
  /**   Label of the backup setting */
  label: Scalars["String"];
  /**
   *   A list of backup settings identifiers which cause the backup setting to become required. If at least one of the
   *  settings pointed by identifiers stored in requiredBy field has a non-empty value,
   *  then the backup setting described by an instance of this type should become required,
   *  regardless of isRequired flag value
   */
  requiredBy: Array<Scalars["String"]>;
  /**   Allowed type of the backup setting value */
  type: BackupSettingType;
};

export type BackupSettingCandidateValue = {
  __typename?: "BackupSettingCandidateValue";
  /**   Label of a candidate value */
  label: Scalars["String"];
  value: Scalars["String"];
};

export type BackupSettingInput = {
  /**   Backup setting id (the available list of values can be obtained by query resourceTypeBackupSettings) */
  id: Scalars["String"];
  /**   Backup setting value */
  value: Scalars["String"];
};

/**   The list of backup setting value types. */
export enum BackupSettingType {
  Boolean = "BOOLEAN",
  Int = "INT",
  String = "STRING",
  StringList = "STRING_LIST",
}

export type BackupSettingsSearchCriteria = {
  customerId: Scalars["String"];
  resourceType: Scalars["String"];
};

export type BackupSetup = {
  __typename?: "BackupSetup";
  /**   List of backup settings */
  backupSettings: Array<BackupSetting>;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Backup setup ID */
  id: Scalars["String"];
  /**   Name of backup setup */
  name: Scalars["String"];
  /**   Posthook setup */
  postHook?: Maybe<Hook>;
  /**   Prehook setup */
  preHook?: Maybe<Hook>;
  /**   Resource type, e.g. aws-ebs, aws-ec2 */
  resourceType: Scalars["String"];
  /**   Friendly tag value */
  tagValue: Scalars["String"];
};

export type BackupSetupInput = {
  /**   List of backup settings */
  backupSettings: Array<BackupSettingInput>;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Name of backup setup */
  name: Scalars["String"];
  /**   Posthook setup (optional) */
  postHook?: InputMaybe<HookInput>;
  /**   Prehook setup (optional) */
  preHook?: InputMaybe<HookInput>;
  /**   Resource type, e.g. aws-ebs, aws-ec2 */
  resourceType: Scalars["String"];
};

/**   Input used to select a backup which should be return by backupSetup query. */
export type BackupSetupSearchCriteria = {
  /**   Identifier of backup setup owned by customer pointed by customerId field. */
  backupSetupId: Scalars["String"];
  /**   Identifier of a customer owning a backup setup. */
  customerId: Scalars["String"];
};

export type BackupSetupsSearchCriteria = {
  customerId: Scalars["String"];
  /**
   *   Optional resource type for which the list of backup setups is returned. If not provided
   *  then the list of all backup setups for given customer is returned.
   */
  resourceType?: InputMaybe<Scalars["String"]>;
};

export type BackupTagNames = {
  __typename?: "BackupTagNames";
  /**  The list of tag's names that controls whether the backup is enabled or not. */
  backupEnabledTagNames: Array<Scalars["String"]>;
  /**  The list of tag's names that contains policy name to be applied. */
  policyTagNames: Array<Scalars["String"]>;
  /**  The list of tag's names that contains setup name to be applied. */
  setupTagNames: Array<Scalars["String"]>;
};

export type BestAllowedPolicySettings = {
  __typename?: "BestAllowedPolicySettings";
  /**  Max number of days for primary snapshot retention. */
  maxPrimarySnapshotRetentionInDays: Scalars["Int"];
  /**  Max number of retained primary snapshots. */
  maxPrimarySnapshotRetentionQuantity: Scalars["Int"];
  /**  Max number of days for replicated snapshot retention. */
  maxReplicaSnapshotRetentionInDays: Scalars["Int"];
  /**  Max number of retained replicated snapshots. */
  maxReplicaSnapshotRetentionQuantity: Scalars["Int"];
  /**   Minimal allowed RPO for the customer. */
  minRPOInHours: Scalars["Int"];
};

export type CategoriesWithResouces = {
  __typename?: "CategoriesWithResouces";
  category: Scalars["String"];
  resources: Array<Scalars["String"]>;
};

/**   Change backup policy and/or setups for a set of resources. */
export type ChangeBackupPolicyAndSetupsInput = {
  /**
   *   Id of backup policy to be set. If omitted or equal to null, then backup policy will be detached from matched resources.
   *  This will also cause backup to be disabled for selected resources.
   */
  backupPolicyId?: InputMaybe<Scalars["String"]>;
  /**   Identifier of customers whose resources should be modified. */
  customerId: Scalars["String"];
  /**   Filters which determine which resources should be modified. */
  filters: Array<FilterInput>;
  /**
   *   Optional filter containing a list identifiers of resources which should be modified.
   *  Note that policies and setups changes will affect only resources with matching identifiers AND matching criteria
   *  defined in filters field.
   */
  resourceIDs?: InputMaybe<Array<Scalars["String"]>>;
  /**
   *   List of setup identifiers to be assigned with the selected resources. This field is deprecated.
   *  setupsToResourcesTypesAssignments should be used instead. If setupsToResourcesTypesAssignments is not empty,
   *  then setupsIds field is ignored.
   */
  setupsIds?: InputMaybe<Array<Scalars["String"]>>;
  /**
   *   A list of pairs defining which setups should be attached to resources having specified type.
   *  Note that the list can't contain two or more elements which define setup for the same resource type, because it
   *  would be ambiguous. In such case, a validation error is returned.
   */
  setupsToResourcesTypesAssignments?: InputMaybe<
    Array<SetupToResourceTypeAssignment>
  >;
};

/**
 *   Enable or disable backup for a set of resources (given by 'resourceIDs') or
 *  resources selected by 'filters'
 */
export type ChangeBackupStateInput = {
  customerId: Scalars["String"];
  filters: Array<FilterInput>;
  resourceIDs?: InputMaybe<Array<Scalars["String"]>>;
  /**   State to set. */
  state: Scalars["Boolean"];
};

export enum CloudProvider {
  Aws = "AWS",
  AwsChina = "AWS_CHINA",
  Azure = "AZURE",
  Gcp = "GCP",
  Ibmcloud = "IBMCLOUD",
}

/**  The CreateAccountAwsChinaInput contains data required to register an AWS China account. */
export type CreateAccountAwsChinaInput = {
  /**  A field which determines if it's an account under protection or it's used for storing replicas. */
  accountType: AccountType;
  /**
   *  Access credentials for AWS China account. For AWS China, the credentials must contain the staticCredentials field.
   * The rolesChain field is optional. If its value is null, then AutoBackup assumes that a user wants to use a role
   * generated by the awsChinaAccountAccessRoleTemplate query. If a user doesn't want to use roles at all, then the
   * credentials rolesChain field must be explicitly set to empty list.
   */
  credentials: CredentialsAwsInput;
  /**  An id of the customer who owns the account. */
  customerId: Scalars["String"];
  /**  The account name. */
  name: Scalars["String"];
  /**  The number identifying an AWS account e.g. 123456789012 */
  number: Scalars["String"];
};

/**  The CreateAccountAwsInput contains data required to register an AWS account which is not registered in CMP. */
export type CreateAccountAwsInput = {
  /**  A field which determines if it's an account under protection or it's used for storing replicas. */
  accountType: AccountType;
  /**
   *  Optional access credentials for AWS account.
   * If not provided, the AutoBackup will assume that credentials were created by a cloud formation template
   * downloaded from the awsAccountAccessRoleTemplate query.
   */
  credentials?: InputMaybe<CredentialsAwsInput>;
  /**  An id of the customer who owns the account. */
  customerId: Scalars["String"];
  /**  The account name. */
  name: Scalars["String"];
  /**  The number identifying an AWS account e.g. 123456789012 */
  number: Scalars["String"];
};

/**  The CreateAccountAzureInput contains data required to register an Azure account which is not registered in CMP. */
export type CreateAccountAzureInput = {
  /**  Credentials required to access Azure subscription. */
  credentials: AzureCredentialsInput;
  /**  An id of the customer who owns the account. */
  customerId: Scalars["String"];
  /**  The account name. */
  name: Scalars["String"];
  /**  The number identifying an Azure subscription e.g. 11002211-bdbd-4496-98ee-f2f255699f70 */
  subscriptionId: Scalars["String"];
};

/**  The CreateAccountGcpInput contains data required to register an GCP account (project). */
export type CreateAccountGcpInput = {
  /**  A field which determines if it's an account under protection or it's used for storing replicas. */
  accountType: AccountType;
  /**  Credentials required to access GCP project. */
  credentials: GcpCredentialsInput;
  /**  An id of the customer who owns the account. */
  customerId: Scalars["String"];
  /**  The account name. */
  name: Scalars["String"];
  /**  The identifier identifying an GCP project e.g. example-project */
  projectId: Scalars["String"];
};

/**  The CreateAccountIbmCloudInput contains data required to register an IBM Cloud account. */
export type CreateAccountIbmCloudInput = {
  /**  A field which determines if it's an account under protection or it's used for storing replicas. Only the PROTECTED type is currently supported. */
  accountType: AccountType;
  /**  Credentials required to access IBM account. */
  credentials: IbmCloudCredentialsInput;
  /**  An id of the customer who owns the account. */
  customerId: Scalars["String"];
  /**  ID if the IBM Cloud account. Example: a1b2c3d4e5f61234567890fedcba4321 */
  ibmCloudAccountId: Scalars["String"];
  /**  The account name. */
  name: Scalars["String"];
};

export type CreateApiKeyInput = {
  alias: Scalars["String"];
  owner: Scalars["String"];
};

export type CreateApiKeyResult = {
  __typename?: "CreateApiKeyResult";
  /**   The API key metadata. */
  apiKey: ApiKey;
  /**   The actual API key string to be used in requests authentication. Please save it as it cannot be retrieved later. */
  apiKeyString: Scalars["String"];
};

export type CreateBackupPolicyInput = {
  customerId: Scalars["String"];
  policyName: Scalars["String"];
  policySettings?: InputMaybe<Array<PolicySettingsInput>>;
  /**  Deprecated field */
  primarySnapshotRetentionCondition?: InputMaybe<RetentionCondition>;
  /**  Deprecated field */
  primarySnapshotRetentionThreshold?: InputMaybe<Scalars["Int"]>;
  removePrimarySnapshotsAfterResourceDeletion?: InputMaybe<Scalars["Boolean"]>;
  removeReplicaSnapshotsAfterResourceDeletion?: InputMaybe<Scalars["Boolean"]>;
  /**  Deprecated field */
  replicaSnapshotRetentionCondition?: InputMaybe<RetentionCondition>;
  /**  Deprecated field */
  replicaSnapshotRetentionThreshold?: InputMaybe<Scalars["Int"]>;
  /**  Deprecated field */
  rpoInHours?: InputMaybe<Scalars["Int"]>;
  timeAwarePolicySettings?: InputMaybe<TimeAwarePolicySettingsInput>;
  type?: InputMaybe<PolicyType>;
};

export type CreateCustomerInput = {
  backupPoliciesBoundary: BackupPoliciesBoundaryInput;
  name: Scalars["String"];
};

export type CreateDisasterRecoveryPlanInput = {
  /**   Cloud provider */
  cloudProvider: CloudProvider;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Notification recipients */
  emails: Array<Scalars["String"]>;
  /**   Frequency of disaster recovery plan */
  frequencyInMonths: Scalars["Int"];
  /**
   *   The kmsKey is used by AutoBackup to copy encrypted AWS snapshots to restore region.
   *  Following formats are correct: key ID (for example, key/1234abcd-12ab-34cd-56ef-1234567890ab),
   *  key alias (for example, alias/ExampleAlias), key ARN (for example, arn:aws:kms:us-east-1:012345678910:key/abcd1234-a123-456a-a12b-a123b4cd56ef).
   */
  kmsKey?: InputMaybe<Scalars["String"]>;
  /**   Plan name */
  name: Scalars["String"];
  /**   How many days before notification should be sent */
  remindDaysBefore: Scalars["Int"];
  /**   Region where DR testing should be performed (creating AMI, moving Snapshots). */
  restoreRegion: Scalars["String"];
  /**   Plan start date (UNIX timestamp) */
  startTimestamp: Scalars["Int"];
  /**   Attached templates */
  templatesResourcesMapping?: InputMaybe<Array<TemplateResourcesMappingInput>>;
};

export type CreateTemplateInput = {
  /**   Cloud provider */
  cloudProvider: CloudProvider;
  /**   Template Content */
  content: Scalars["String"];
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Template Name */
  name: Scalars["String"];
};

/**   The credentials for AWS account, either as a pair of access key/secret access key, or a list of IAM roles. */
export type CredentialsAwsInput = {
  /**   The list of roles used to get the credentials. */
  rolesChain?: InputMaybe<Array<AccountAwsRoleInput>>;
  /**   Static credentials for the account. */
  staticCredentials?: InputMaybe<StaticAwsCredentialsInput>;
};

export type Customer = {
  __typename?: "Customer";
  /**
   *   The list of accounts for which the logged user has ADMIN rights
   * @deprecated No longer supported
   */
  adminAccountIds: Array<Scalars["String"]>;
  /**   Customer ID */
  id: Scalars["String"];
  /**   Customer name */
  name: Scalars["String"];
  /**
   *   The list of accounts for which the logged user has READ_ONLY access
   * @deprecated No longer supported
   */
  readOnlyAccountIds: Array<Scalars["String"]>;
  /**   The customer role (READ_ONLY, ADMIN, SUPER_ADMIN) */
  role: Scalars["String"];
};

export type CustomerAccess = {
  __typename?: "CustomerAccess";
  customer: CustomerBasic;
  roles: Array<UserRole>;
};

export type CustomerAccessesPage = {
  __typename?: "CustomerAccessesPage";
  data: Array<Maybe<CustomerAccess>>;
  totalNumberOfCustomers: Scalars["Int"];
  totalNumberOfPages: Scalars["Int"];
};

export type CustomerBasic = {
  __typename?: "CustomerBasic";
  backupPoliciesBoundary: BackupPoliciesBoundary;
  /**   Customer ID */
  id: Scalars["String"];
  /**   Customer name */
  name: Scalars["String"];
};

export type CustomerInfo = {
  __typename?: "CustomerInfo";
  backupPoliciesBoundary: BackupPoliciesBoundary;
  id: Scalars["String"];
  name: Scalars["String"];
};

export enum CustomerReportType {
  BackupEvent = "BACKUP_EVENT",
}

export type DisableCustomerInput = {
  customerId: Scalars["String"];
};

export type DisasterRecoveryPlan = {
  __typename?: "DisasterRecoveryPlan";
  /**   Cloud provider */
  cloudProvider: CloudProvider;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Notification recipients */
  emails: Array<Scalars["String"]>;
  /**   Frequency of disaster recovery plan */
  frequencyInMonths: Scalars["Int"];
  /**   Plan ID */
  id: Scalars["String"];
  /**
   *   The kmsKey is used by AutoBackup to copy encrypted AWS snapshots to restore region.
   *  Following formats are correct: key ID (for example, key/1234abcd-12ab-34cd-56ef-1234567890ab),
   *  key alias (for example, alias/ExampleAlias), key ARN (for example, arn:aws:kms:us-east-1:012345678910:key/abcd1234-a123-456a-a12b-a123b4cd56ef).
   */
  kmsKey?: Maybe<Scalars["String"]>;
  /**   Plan name */
  name: Scalars["String"];
  /**   How many days before notification should be sent */
  remindDaysBefore: Scalars["Int"];
  /**   Region where DR testing should be performed (creating AMI, moving Snapshots). */
  restoreRegion: Scalars["String"];
  /**   Plan start date (UNIX timestamp) */
  startTimestamp: Scalars["Int"];
  /**   Attached plan */
  templatesResourcesMapping?: Maybe<Array<TemplateResourcesMapping>>;
};

export type DisasterRecoveryPlanSearchCriteria = {
  /**   Customer ID for which the disaster recovery plan is asked */
  customerId: Scalars["String"];
  /**   Plan ID */
  planId: Scalars["String"];
};

export type DisasterRecoveryPlansPage = {
  __typename?: "DisasterRecoveryPlansPage";
  data: Array<DisasterRecoveryPlan>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfPlans: Scalars["Int"];
};

export type DisasterRecoveryPlansSearchCriteria = {
  /**   Customer ID for which the disaster recovery plans are asked */
  customerId: Scalars["String"];
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type DisasterRecoveryRecord = {
  __typename?: "DisasterRecoveryRecord";
  /**   Person who is responsible for performing the disaster recovery */
  assignee: Scalars["String"];
  /**   Error messages during recovering jobs. */
  errorMessages?: Maybe<Array<Scalars["String"]>>;
  /**   Finish datetime of the disaster recovery (UNIX timestamp) */
  finishTimestamp?: Maybe<Scalars["Int"]>;
  /**   Record ID */
  id: Scalars["String"];
  /**   Generated by AutoBackup links to the provider website to continue resources recovering. */
  links?: Maybe<Array<TemplateLink>>;
  /**   Note field contains additional information about Disaster recovery, for example: error message, link to documents. */
  note: Scalars["String"];
  /**   Disaster recovery plan */
  plan: DisasterRecoveryPlan;
  /**   Region where the restore has been performed. */
  restoreRegion: Scalars["String"];
  /**   Start datetime of the disaster recovery (UNIX timestamp) */
  startTimestamp: Scalars["Int"];
  /**   Status of the disaster recovery */
  status: DisasterRecoveryStatus;
};

export type DisasterRecoveryRecordsPage = {
  __typename?: "DisasterRecoveryRecordsPage";
  data: Array<DisasterRecoveryRecord>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfRecords: Scalars["Int"];
};

export type DisasterRecoveryRecordsReport = {
  __typename?: "DisasterRecoveryRecordsReport";
  data: Scalars["String"];
};

export type DisasterRecoveryRecordsReportInput = {
  customerId: Scalars["String"];
  timeRange: TimeRange;
};

export type DisasterRecoveryRecordsSearchCriteria = {
  /**   Customer ID for which the disaster recovery records are asked */
  customerId: Scalars["String"];
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type DisasterRecoverySnapshotsSearchCriteria = {
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Plan ID */
  planId: Scalars["String"];
  /**   The date from snapshots should be restored (UNIX timestamp) */
  recoveryPointTimestamp: Scalars["Int"];
};

/**   Status of the disaster recovery */
export enum DisasterRecoveryStatus {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Ready = "READY",
  Success = "SUCCESS",
}

export type DismissMessageInput = {
  customerId: Scalars["String"];
  messageId: Scalars["String"];
};

export type EmailConfig = {
  __typename?: "EmailConfig";
  address: Scalars["String"];
};

export type EmailConfigInput = {
  address: Scalars["String"];
};

export type ExternallyBackedUpResource = {
  __typename?: "ExternallyBackedUpResource";
  backupEnabled: Scalars["Boolean"];
  backupProvider: Scalars["String"];
  cloudProvider: CloudProvider;
  id: Scalars["String"];
  lastBackupErrorMessage?: Maybe<Scalars["String"]>;
  lastBackupStatus?: Maybe<Scalars["String"]>;
  rpoInHours?: Maybe<Scalars["Int"]>;
  updatedAtTimestamp: Scalars["Int"];
};

export type ExternallyBackedUpResourcesPage = {
  __typename?: "ExternallyBackedUpResourcesPage";
  data: Array<ExternallyBackedUpResource>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfResources: Scalars["Int"];
};

export type ExternallyBackedUpResourcesSearchCriteria = {
  customerId: Scalars["String"];
  filters: Array<FilterInput>;
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type Filter = {
  __typename?: "Filter";
  /**   Filter identifier */
  id: Scalars["String"];
  /**   The human readable filter label (e.g. Account) */
  name: Scalars["String"];
  /**   The filter type */
  type?: Maybe<FilterType>;
  /**   The optional list of possible values. */
  values?: Maybe<Array<FilterValue>>;
};

export type FilterInput = {
  /**   Filter ID (the list of available filter ids can be obtained from query 'filters' */
  id: Scalars["String"];
  /**   Filter values */
  values: Array<Scalars["String"]>;
};

export enum FilterType {
  Boolean = "BOOLEAN",
  SelectMulti = "SELECT_MULTI",
  SelectOne = "SELECT_ONE",
  Text = "TEXT",
  Timestamp = "TIMESTAMP",
}

export type FilterValue = {
  __typename?: "FilterValue";
  /**   Human readable label for the value */
  label: Scalars["String"];
  value: Scalars["String"];
};

/**   The list of possible filter groups */
export enum FilteredDataType {
  BackupEvents = "BACKUP_EVENTS",
  BackupEventResources = "BACKUP_EVENT_RESOURCES",
  ExternallyBackedUpResources = "EXTERNALLY_BACKED_UP_RESOURCES",
  Resources = "RESOURCES",
  TemplateResources = "TEMPLATE_RESOURCES",
}

export type FiltersSearchCriteria = {
  customerId: Scalars["String"];
  /**   The group for which the possible filters are fetched (e.g. RESOURCES to get filters used for searching resources) */
  filteredDataType: FilteredDataType;
};

/**  The enumeration of supported snapshots taking frequencies. */
export enum Frequency {
  Days = "DAYS",
  Hours = "HOURS",
  Months = "MONTHS",
  Weeks = "WEEKS",
}

export type GcpCredentialsInput = {
  authProviderX509CertUrl: Scalars["String"];
  authUri: Scalars["String"];
  clientEmail: Scalars["String"];
  clientId: Scalars["String"];
  clientX509CertUrl: Scalars["String"];
  privateKey: Scalars["String"];
  privateKeyId: Scalars["String"];
  projectId: Scalars["String"];
  tokenUri: Scalars["String"];
  type: Scalars["String"];
};

export type GrantCustomerRoleToApiKeyInput = {
  /**   Customer ID. */
  customerId: Scalars["ID"];
  /**   API key ID. */
  id: Scalars["String"];
  /**   Role to be added for given customer. */
  role: UserRole;
};

export type GrantCustomerRoleToUserInput = {
  /**   Customer ID. */
  customerId: Scalars["ID"];
  /**   User email. */
  email: Scalars["String"];
  /**   Role to be added for given customer. */
  role: UserRole;
};

export type HistoryEntry = {
  __typename?: "HistoryEntry";
  eventCount: Scalars["Int"];
  month: Scalars["Int"];
};

/**  The hook type contains hook's type and endpoint (http or Lambda's ARN). */
export type Hook = {
  __typename?: "Hook";
  /**   Endpoint, e.g. (URL in case of URL type or Lambda ARN in case of LAMBDA_ARN) */
  endpoint: Scalars["String"];
  /**   Type of the hook */
  type: HookType;
};

export type HookInput = {
  endpoint: Scalars["String"];
  /**   Type of hook */
  type: HookType;
};

/**  The enumeration of supported hooks types. */
export enum HookType {
  LambdaArn = "LAMBDA_ARN",
  Url = "URL",
}

export type IbmCloudCredentialsInput = {
  apiKey: Scalars["String"];
};

/**  The LastBackupStatus type stores information about last backup error messages and status. */
export type LastBackupStatus = {
  __typename?: "LastBackupStatus";
  /**  Field indicating status of last backup operation. */
  backupStatus: Scalars["String"];
  /**  Field containing information about an error which occurred during primary backup execution. */
  primaryBackupErrorMessage?: Maybe<Scalars["String"]>;
  /**  Field containing information about an error which occurred during replication. */
  replicationErrorMessage?: Maybe<Scalars["String"]>;
};

export type LatestResourceSnapshotSearchCriteria = {
  customerId: Scalars["String"];
  resourceId: Scalars["String"];
  /**
   *   Optional parameter specifying type of latest snapshot to be returned.
   *  By default snapshot of type PRIMARY is returned.
   */
  snapshotType?: InputMaybe<SnapshotType>;
};

export type MatchedResourcesType = {
  __typename?: "MatchedResourcesType";
  numberOfResources: Scalars["Int"];
  resourceTypeName: Scalars["String"];
};

export type MatchedResourcesTypesSearchCriteria = {
  customerId: Scalars["String"];
  filters: Array<FilterInput>;
  onlySelectedIds?: InputMaybe<Array<Scalars["String"]>>;
};

export type Message = {
  __typename?: "Message";
  category: MessageCategory;
  customerId: Scalars["String"];
  id: Scalars["String"];
  message: Scalars["String"];
  type: MessageType;
};

export enum MessageCategory {
  DisasterRecovery = "DISASTER_RECOVERY",
  General = "GENERAL",
}

export enum MessageType {
  Critical = "CRITICAL",
  Info = "INFO",
  Warning = "WARNING",
}

export type MessagesPage = {
  __typename?: "MessagesPage";
  data: Array<Message>;
  nextPageCursor?: Maybe<Scalars["String"]>;
};

export type MessagesSearchCriteria = {
  customerId: Scalars["String"];
  pageCursor?: InputMaybe<Scalars["String"]>;
};

export enum MessagesSendingFrequency {
  OncePerDay = "ONCE_PER_DAY",
  OncePerEvent = "ONCE_PER_EVENT",
}

export type Mutation = {
  __typename?: "Mutation";
  /**   The mutation allows to add new resource. */
  addResource?: Maybe<Resource>;
  /**   The mutation adds a new user. */
  addUser: User;
  /**   The mutation assigning provided backup policy and setups to the set of selected resources. */
  changeBackupPolicyAndSetups: Scalars["Boolean"];
  /**   Enable/disable backup on selected resources. */
  changeBackupState: Scalars["Boolean"];
  /**
   *  The mutation creating a new AWS account definition.
   * It is used to register an account.
   * IMPORTANT
   * Before calling this mutation either use awsAccountAccessRoleTemplate query to generate role template,
   * apply the template and then call the this mutation, or in the input parameters
   * put the list of roles to use or the static credentials. If there is no errors, it
   * returns the identifier of the new account.
   */
  createAccountAws: AccountAccessRoleAws;
  /**
   *  The mutation creating a new AWS China account definition.
   * It is used to register an account.
   */
  createAccountAwsChina: Scalars["String"];
  /**
   *  The mutation creating a new Azure account definition.
   * It is used to register an account.
   * If there are no errors, it returns the identifier of the new account.
   */
  createAccountAzure: Scalars["String"];
  /**
   *  The mutation creating a new GCP account (project) definition.
   * It is used to register an account.
   * If there are no errors, it returns the identifier of the new account.
   */
  createAccountGcp: Scalars["String"];
  /**
   *  The mutation creating a new IBM Cloud account definition.
   * It is used to register an account.
   * If there are no errors, it returns the identifier of the new account.
   */
  createAccountIbmCloud: Scalars["String"];
  /**   The mutation creates a new API key for any entity. Only Super Admin can perform this operation. */
  createApiKey: CreateApiKeyResult;
  /**   Creates backup policy. */
  createBackupPolicy?: Maybe<BackupPolicy>;
  /**   Creates backup setup. */
  createBackupSetup?: Maybe<BackupSetup>;
  createCustomer: CustomerInfo;
  /**   The mutation allows to create disaster recovery plan. */
  createDisasterRecoveryPlan?: Maybe<DisasterRecoveryPlan>;
  /**
   *  The mutation which saves notification group belonging to a specified user.
   * It can be used to create or update the notifications group.
   */
  createNotificationGroup?: Maybe<NotificationGroup>;
  /**   The mutation allows to put the template for the disaster recovery purpose. */
  createTemplate?: Maybe<Template>;
  disableCustomer: Scalars["String"];
  /**   It dismiss the internal message. */
  dismissMessage: Scalars["String"];
  /**   The mutation grants a new customer access role to the API key. Only Super Admin can perform this operation. */
  grantCustomerRoleToApiKey: Scalars["Boolean"];
  /**   The mutation grants a new customer access role to the user. */
  grantCustomerRoleToUser: Scalars["Boolean"];
  /**   The mutation grants Super Admin role to the user. */
  grantSuperAdmin: Scalars["Boolean"];
  /**  The mutation triggers the event scanStatusChanged (internal usage) */
  notifyAboutScanStatusChange?: Maybe<ScanStatusUpdateResult>;
  /**  The mutation triggers the event newMessage (internal usage) */
  notifyNewMessage?: Maybe<Message>;
  /**  The mutation allows providing the tag definitions that control the backup process. */
  provideBackupTagNames: BackupTagNames;
  /**  The removeAccount mutation removes the cloud account from the Backup. */
  removeAccount: Account;
  /**   The mutation removes the API key. Only Super Admin can perform this operation. */
  removeApiKey: Scalars["Boolean"];
  /**   Removes backup policy. */
  removeBackupPolicy: Scalars["Boolean"];
  /**   Remove backup setups */
  removeBackupSetup: Scalars["Boolean"];
  /**  The mutation allows to remove disaster recovery plan. */
  removeDisasterRecoveryPlan: Scalars["Boolean"];
  /**  The mutation for removing notification groups. */
  removeNotificationGroup: Scalars["Boolean"];
  /**  The mutation allows to remove disaster recovery template. */
  removeTemplate: Scalars["Boolean"];
  /**   The mutation removes the user. */
  removeUser: Scalars["Boolean"];
  /**   The mutation revokes the customer access role from the API key. Only Super Admin can perform this operation. */
  revokeCustomerRoleFromApiKey: Scalars["Boolean"];
  /**   The mutation revokes the customer access role from the user. */
  revokeCustomerRoleFromUser: Scalars["Boolean"];
  /**   The mutation revokes Super Admin role from the user. */
  revokeSuperAdmin: Scalars["Boolean"];
  /**   The mutation creates a new API key for the user requesting it. Anyone can perform this operation. */
  selfCreateApiKey: CreateApiKeyResult;
  /**
   *   The mutation grants a new customer access role to the API key belonging to the user requesting it.
   *  Anyone can perform this operation.
   */
  selfGrantCustomerRoleToApiKey: Scalars["Boolean"];
  /**   The mutation removes the API key belonging to the user requesting it. Anyone can perform this operation. */
  selfRemoveApiKey: Scalars["Boolean"];
  /**
   *   The mutation revokes the customer access role from the API key belonging to the user requesting it.
   *  Anyone can perform this operation.
   */
  selfRevokeCustomerRoleFromApiKey: Scalars["Boolean"];
  /**  The mutation allows to start disaster recovery. */
  startDisasterRecovery?: Maybe<DisasterRecoveryRecord>;
  /**   The mutation allows to trigger backup (generate new event) on selected resources. */
  triggerBackup: Scalars["Boolean"];
  /**  The mutation which triggers scan of the whole customer (all accounts) */
  triggerScan: ScanTriggerResult;
  /**  The mutation triggers scan on specific cloud account */
  triggerScanOnCloudAccount: ScanTriggerResult;
  /**   Update backup setup. */
  updateBackupSetup?: Maybe<BackupSetup>;
  updateCustomer: CustomerInfo;
  /**   The mutation allows to update disaster recovery plan. */
  updateDisasterRecoveryPlan?: Maybe<DisasterRecoveryPlan>;
  /**   The mutation allows to update disaster recovery record. */
  updateDisasterRecoveryRecord?: Maybe<DisasterRecoveryRecord>;
  /**   The mutation allows to update the template for the disaster recovery purpose. */
  updateTemplate?: Maybe<Template>;
  /**  The mutation allows to edit user's profile. */
  updateUserProfile: UserProfile;
  /**  The mutation allows to validate disaster recovery template and returns template's parameters. */
  validateTemplate: ValidateTemplateResult;
};

export type MutationAddResourceArgs = {
  input: AddResourceInput;
};

export type MutationAddUserArgs = {
  input: AddUserInput;
};

export type MutationChangeBackupPolicyAndSetupsArgs = {
  input: ChangeBackupPolicyAndSetupsInput;
};

export type MutationChangeBackupStateArgs = {
  input: ChangeBackupStateInput;
};

export type MutationCreateAccountAwsArgs = {
  input: CreateAccountAwsInput;
};

export type MutationCreateAccountAwsChinaArgs = {
  input: CreateAccountAwsChinaInput;
};

export type MutationCreateAccountAzureArgs = {
  input: CreateAccountAzureInput;
};

export type MutationCreateAccountGcpArgs = {
  input: CreateAccountGcpInput;
};

export type MutationCreateAccountIbmCloudArgs = {
  input: CreateAccountIbmCloudInput;
};

export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};

export type MutationCreateBackupPolicyArgs = {
  input: CreateBackupPolicyInput;
};

export type MutationCreateBackupSetupArgs = {
  input: BackupSetupInput;
};

export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};

export type MutationCreateDisasterRecoveryPlanArgs = {
  input: CreateDisasterRecoveryPlanInput;
};

export type MutationCreateNotificationGroupArgs = {
  input: NotificationGroupInput;
};

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};

export type MutationDisableCustomerArgs = {
  input: DisableCustomerInput;
};

export type MutationDismissMessageArgs = {
  input: DismissMessageInput;
};

export type MutationGrantCustomerRoleToApiKeyArgs = {
  input: GrantCustomerRoleToApiKeyInput;
};

export type MutationGrantCustomerRoleToUserArgs = {
  input: GrantCustomerRoleToUserInput;
};

export type MutationGrantSuperAdminArgs = {
  email: Scalars["String"];
};

export type MutationNotifyAboutScanStatusChangeArgs = {
  input: ScanStatusUpdateInput;
};

export type MutationNotifyNewMessageArgs = {
  input: NewMessageUpdateInput;
};

export type MutationProvideBackupTagNamesArgs = {
  input: ProvideBackupTagNamesInput;
};

export type MutationRemoveAccountArgs = {
  input?: InputMaybe<RemoveAccountInput>;
};

export type MutationRemoveApiKeyArgs = {
  id: Scalars["ID"];
};

export type MutationRemoveBackupPolicyArgs = {
  input: RemoveBackupPolicyInput;
};

export type MutationRemoveBackupSetupArgs = {
  input: RemoveBackupSetupInput;
};

export type MutationRemoveDisasterRecoveryPlanArgs = {
  input: RemoveDisasterRecoveryPlanInput;
};

export type MutationRemoveNotificationGroupArgs = {
  input: RemoveNotificationGroupInput;
};

export type MutationRemoveTemplateArgs = {
  input: RemoveTemplateInput;
};

export type MutationRemoveUserArgs = {
  email: Scalars["String"];
};

export type MutationRevokeCustomerRoleFromApiKeyArgs = {
  input: RevokeCustomerRoleFromApiKeyInput;
};

export type MutationRevokeCustomerRoleFromUserArgs = {
  input: RevokeCustomerRoleFromUserInput;
};

export type MutationRevokeSuperAdminArgs = {
  email: Scalars["String"];
};

export type MutationSelfCreateApiKeyArgs = {
  input: SelfCreateApiKeyInput;
};

export type MutationSelfGrantCustomerRoleToApiKeyArgs = {
  input: GrantCustomerRoleToApiKeyInput;
};

export type MutationSelfRemoveApiKeyArgs = {
  id: Scalars["ID"];
};

export type MutationSelfRevokeCustomerRoleFromApiKeyArgs = {
  input: RevokeCustomerRoleFromApiKeyInput;
};

export type MutationStartDisasterRecoveryArgs = {
  input: StartDisasterRecoveryInput;
};

export type MutationTriggerBackupArgs = {
  input?: InputMaybe<TriggerBackupInput>;
};

export type MutationTriggerScanArgs = {
  input: TriggerScanInput;
};

export type MutationTriggerScanOnCloudAccountArgs = {
  input: TriggerScanOnCloudAccountInput;
};

export type MutationUpdateBackupSetupArgs = {
  input: UpdateBackupSetupInput;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};

export type MutationUpdateDisasterRecoveryPlanArgs = {
  input: UpdateDisasterRecoveryPlanInput;
};

export type MutationUpdateDisasterRecoveryRecordArgs = {
  input: UpdateDisasterRecoveryRecordInput;
};

export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};

export type MutationUpdateUserProfileArgs = {
  input: UserProfileInput;
};

export type MutationValidateTemplateArgs = {
  input: ValidateTemplateInput;
};

export type MyApiKeysSearchCriteria = {
  /**   If no page number is provided, the first one will be returned. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type NewMessageUpdateInput = {
  customerId: Scalars["String"];
  id: Scalars["String"];
  message: Scalars["String"];
  type: MessageType;
};

export type NotificationChannel = EmailConfig | PagerDutyConfig | SlackConfig;

export type NotificationChannelInput = {
  channelType: NotificationChannelType;
  email?: InputMaybe<EmailConfigInput>;
  pagerDuty?: InputMaybe<PagerDutyConfigInput>;
  slack?: InputMaybe<SlackConfigInput>;
};

export enum NotificationChannelType {
  Email = "EMAIL",
  Pagerduty = "PAGERDUTY",
  Slack = "SLACK",
}

export type NotificationGroup = {
  __typename?: "NotificationGroup";
  channels: Array<NotificationChannel>;
  frequency: MessagesSendingFrequency;
  id: Scalars["String"];
  name: Scalars["String"];
  severities: Array<NotificationSeverity>;
};

export type NotificationGroupInput = {
  channels: Array<NotificationChannelInput>;
  customerId: Scalars["String"];
  frequency: MessagesSendingFrequency;
  name: Scalars["String"];
  severities: Array<NotificationSeverity>;
};

export enum NotificationSeverity {
  Error = "ERROR",
  Info = "INFO",
  Success = "SUCCESS",
  Warning = "WARNING",
}

/**  The Order is an enum for sorting purpose. */
export enum Order {
  Asc = "ASC",
  Desc = "DESC",
}

export type PagerDutyConfig = {
  __typename?: "PagerDutyConfig";
  routingKey: Scalars["String"];
};

export type PagerDutyConfigInput = {
  routingKey: Scalars["String"];
};

export type PolicyCompliance = {
  __typename?: "PolicyCompliance";
  numberOfBackedUpResources: Scalars["Int"];
  numberOfCompliantResources: Scalars["Int"];
};

/**  The PolicySettings type represents single retention settings */
export type PolicySettings = {
  __typename?: "PolicySettings";
  /**  Snapshots taking frequencies. */
  frequency: Frequency;
  /**  Backups retention settings. */
  retention: SnapshotsRetention;
  /**  A desirable time interval between resource backups */
  rpo: Scalars["Int"];
};

export type PolicySettingsInput = {
  /**  Snapshots taking frequencies. */
  frequency: Frequency;
  /**  Backups retention settings. */
  retention: SnapshotsRetentionInput;
  /**  A desirable time interval between resource backups */
  rpo: Scalars["Int"];
};

export enum PolicyType {
  Rpo = "RPO",
  TimeAware = "TIME_AWARE",
}

export type ProtectedResourcesStats = {
  __typename?: "ProtectedResourcesStats";
  numberOfResourcesWithEnabledBackup: Scalars["Int"];
  /**   Protected amount of data in bytes */
  protectedAmountOfDataInBytes: Scalars["String"];
  /**   Total amount of data in bytes */
  totalAmountOfDataInBytes: Scalars["String"];
  totalNumberOfResources: Scalars["Int"];
};

export type ProtectedResourcesStatsSearchCriteria = {
  customerId: Scalars["String"];
};

export type ProvideBackupTagNamesInput = {
  /**  The list of tag's names that controls whether the backup is enabled or not. */
  backupEnabledTagNames: Array<Scalars["String"]>;
  /**  The identifier of customer for which tags are provided. */
  customerId: Scalars["String"];
  /**  The list of tag's names that contains policy name to be applied. */
  policyTagNames: Array<Scalars["String"]>;
  /**  The list of tag's names that contains setup name to be applied. */
  setupTagNames: Array<Scalars["String"]>;
};

export type Query = {
  __typename?: "Query";
  /**  The query returning a list of customers to which the logged user has an access. */
  accessibleCustomers: Array<Customer>;
  /**  The query returning a page of accounts. */
  accounts: AccountsPage;
  /**   The query returns a single API key. Only Super Admin can perform this operation. */
  apiKey: ApiKey;
  /**   The query returns all API keys. Only Super Admin can perform this operation. */
  apiKeys: ApiKeysPage;
  /**   Get the S3 url to the CloudFormation template with the role. */
  awsAccountAccessRoleTemplate: Scalars["String"];
  /**   Get the S3 url to the CloudFormation template with the role. */
  awsChinaAccountAccessRoleTemplate?: Maybe<Scalars["String"]>;
  /**  The query to get the backup event. */
  backupEvent?: Maybe<BackupEvent>;
  /**  The query returning a page of resources belonging to the specified backup event. */
  backupEventResources: BackupEventResourcesPage;
  /**  The query returning backup event statistics, such as success rates, backup size and the rates history. */
  backupEventStats: BackupEventStats;
  /**  The query returning a list of backup events. */
  backupEvents: BackupEventsPage;
  backupHistory?: Maybe<Array<HistoryEntry>>;
  /**  Get the list of available backup policies. */
  backupPolicies: Array<BackupPolicy>;
  /**  Get backup policy. */
  backupPolicy?: Maybe<BackupPolicy>;
  /**  Get selected backup setup. */
  backupSetup?: Maybe<BackupSetup>;
  /**  Get the list of available backup setups. */
  backupSetups: Array<BackupSetup>;
  /**  The query returning backup tags names. */
  backupTagNames?: Maybe<BackupTagNames>;
  /**  Returns the allowed boundaries on backup policies for given customer. */
  bestAllowedPolicySettings?: Maybe<BestAllowedPolicySettings>;
  /**  Get categories with resources mapping */
  categoriesWithResourcesMapping: Array<CategoriesWithResouces>;
  /**   The query returning unpaginated list of all customers. Only Super Admin can perform this operation. */
  customersList: Array<CustomerBasic>;
  /**   The query returns specified disaster recovery plan. */
  disasterRecoveryPlan?: Maybe<DisasterRecoveryPlan>;
  /**   The query return list of disaster recovery plans. */
  disasterRecoveryPlans: DisasterRecoveryPlansPage;
  /**   The query returns disaster recovery records. */
  disasterRecoveryRecords: DisasterRecoveryRecordsPage;
  /**   The query returning data for disaster recovery testing performed in specified time period. */
  disasterRecoveryRecordsReport: DisasterRecoveryRecordsReport;
  /**   This query returns snapshots that will be used to perform disaster recovery. */
  disasterRecoverySnapshots?: Maybe<Array<Snapshot>>;
  exampleQuery?: Maybe<Scalars["Boolean"]>;
  /**  The query returning a list of resources backed up by tools other than AutoBackup. */
  externallyBackedUpResources: ExternallyBackedUpResourcesPage;
  /**  Get the list of applicable filters */
  filters: Array<Filter>;
  /**  The the description of the latest resource snapshot. */
  latestResourceSnapshot?: Maybe<Snapshot>;
  /**  The query returning information about resources types and number of resources matching provided search criteria. */
  matchedResourcesTypes: Array<MatchedResourcesType>;
  /**  Get the list of internal messages. */
  messages: MessagesPage;
  /**   The query returns a single API key owned by the user. Anyone can perform this operation. */
  myApiKey: ApiKey;
  /**   The query returns API keys owned by the user. Anyone can perform this operation. */
  myApiKeys: ApiKeysPage;
  notificationGroups: Array<NotificationGroup>;
  /**  Get number of resources with changed state of backup enabled. */
  numberOfResourcesWithChangedBackupEnabled: Scalars["Int"];
  /**  Get the number of resources for which the change in backup policies will be applied. */
  numberOfResourcesWithChangedBackupPolicy: Scalars["Int"];
  /**  Get the number of resources for which the change in backup setups will be applied. */
  numberOfResourcesWithChangedBackupSetups: Scalars["Int"];
  /**  Returns the statistics on backup policy compliance. */
  policyCompliance?: Maybe<PolicyCompliance>;
  /**  Get the statistics about the protected resources. */
  protectedResourcesStats: ProtectedResourcesStats;
  /**   The query returns the details about the report. */
  report?: Maybe<Report>;
  /**  Get the list of available backup settings for given resource type. */
  resourceTypeBackupSettings: Array<BackupSettingCandidate>;
  /**  The query returning a page of resources. */
  resources: ResourcesPage;
  /**  The query returning types of resources supported by the Backup, optionally filtered by a cloud provider e.g. aws-ec2, azure-vm. */
  resourcesTypes?: Maybe<Array<Scalars["String"]>>;
  /**  The status of the last scanning of given customer. */
  scanStatus?: Maybe<ScanStatusResult>;
  /**  The status of the last scanning of given cloud account. */
  scanStatusAccount?: Maybe<ScanStatusResult>;
  /**  The query returning data for high level report of backups performed in specified time period. */
  summaryBackupsReport: SummaryBackupsReport;
  /**  The query returning regions supported by the Backup for the specified cloud provider. */
  supportedRegions: Array<Scalars["String"]>;
  /**   The query returns specified template. */
  template?: Maybe<Template>;
  /**   The query returns list of available templates. */
  templates: TemplatesPage;
  /**   The query returns a single user. */
  user: User;
  /**  Returns the user profile data. */
  userProfile?: Maybe<UserProfile>;
  /**  The query returning user role to provided customer. */
  userRole?: Maybe<UserRole>;
  /**   The query returns all users. */
  users: UsersPage;
};

export type QueryAccountsArgs = {
  searchCriteria: AccountsSearchCriteria;
};

export type QueryApiKeyArgs = {
  id: Scalars["ID"];
};

export type QueryApiKeysArgs = {
  searchCriteria: ApiKeysSearchCriteria;
};

export type QueryAwsAccountAccessRoleTemplateArgs = {
  input: AccountAwsAccessRoleTemplateInput;
};

export type QueryAwsChinaAccountAccessRoleTemplateArgs = {
  input: AccountAwsChinaAccessRoleTemplateInput;
};

export type QueryBackupEventArgs = {
  searchCriteria: BackupEventSearchCriteria;
};

export type QueryBackupEventResourcesArgs = {
  searchCriteria: BackupEventResourcesSearchCriteria;
};

export type QueryBackupEventStatsArgs = {
  searchCriteria: BackupEventStatsSearchCriteria;
};

export type QueryBackupEventsArgs = {
  searchCriteria: BackupEventsSearchCriteria;
};

export type QueryBackupHistoryArgs = {
  customerId: Scalars["String"];
};

export type QueryBackupPoliciesArgs = {
  customerId: Scalars["String"];
};

export type QueryBackupPolicyArgs = {
  searchCriteria: BackupPolicySearchCriteria;
};

export type QueryBackupSetupArgs = {
  searchCriteria: BackupSetupSearchCriteria;
};

export type QueryBackupSetupsArgs = {
  searchCriteria?: InputMaybe<BackupSetupsSearchCriteria>;
};

export type QueryBackupTagNamesArgs = {
  customerId: Scalars["String"];
};

export type QueryBestAllowedPolicySettingsArgs = {
  customerId: Scalars["String"];
};

export type QueryDisasterRecoveryPlanArgs = {
  searchCriteria: DisasterRecoveryPlanSearchCriteria;
};

export type QueryDisasterRecoveryPlansArgs = {
  searchCriteria: DisasterRecoveryPlansSearchCriteria;
};

export type QueryDisasterRecoveryRecordsArgs = {
  searchCriteria: DisasterRecoveryRecordsSearchCriteria;
};

export type QueryDisasterRecoveryRecordsReportArgs = {
  input: DisasterRecoveryRecordsReportInput;
};

export type QueryDisasterRecoverySnapshotsArgs = {
  searchCriteria: DisasterRecoverySnapshotsSearchCriteria;
};

export type QueryExternallyBackedUpResourcesArgs = {
  searchCriteria: ExternallyBackedUpResourcesSearchCriteria;
};

export type QueryFiltersArgs = {
  searchCriteria: FiltersSearchCriteria;
};

export type QueryLatestResourceSnapshotArgs = {
  searchCriteria: LatestResourceSnapshotSearchCriteria;
};

export type QueryMatchedResourcesTypesArgs = {
  searchCriteria: MatchedResourcesTypesSearchCriteria;
};

export type QueryMessagesArgs = {
  searchCriteria: MessagesSearchCriteria;
};

export type QueryMyApiKeyArgs = {
  id: Scalars["ID"];
};

export type QueryMyApiKeysArgs = {
  searchCriteria: MyApiKeysSearchCriteria;
};

export type QueryNotificationGroupsArgs = {
  customerId: Scalars["String"];
};

export type QueryNumberOfResourcesWithChangedBackupEnabledArgs = {
  input: ChangeBackupStateInput;
};

export type QueryNumberOfResourcesWithChangedBackupPolicyArgs = {
  input: ChangeBackupPolicyAndSetupsInput;
};

export type QueryNumberOfResourcesWithChangedBackupSetupsArgs = {
  input: ChangeBackupPolicyAndSetupsInput;
};

export type QueryPolicyComplianceArgs = {
  customerId: Scalars["String"];
};

export type QueryProtectedResourcesStatsArgs = {
  searchCriteria: ProtectedResourcesStatsSearchCriteria;
};

export type QueryReportArgs = {
  input: ReportInput;
};

export type QueryResourceTypeBackupSettingsArgs = {
  searchCriteria: BackupSettingsSearchCriteria;
};

export type QueryResourcesArgs = {
  searchCriteria: ResourcesSearchCriteria;
};

export type QueryResourcesTypesArgs = {
  cloudProvider?: InputMaybe<CloudProvider>;
};

export type QueryScanStatusArgs = {
  customerId: Scalars["String"];
};

export type QueryScanStatusAccountArgs = {
  input: ScanStatusAccountInput;
};

export type QuerySummaryBackupsReportArgs = {
  searchCriteria: SummaryBackupsReportScope;
};

export type QuerySupportedRegionsArgs = {
  cloudProvider: CloudProvider;
};

export type QueryTemplateArgs = {
  searchCriteria: TemplateSearchCriteria;
};

export type QueryTemplatesArgs = {
  searchCriteria: TemplatesSearchCriteria;
};

export type QueryUserArgs = {
  email: Scalars["String"];
};

export type QueryUserProfileArgs = {
  customerId: Scalars["String"];
};

export type QueryUserRoleArgs = {
  customerId: Scalars["String"];
};

export type QueryUsersArgs = {
  searchCriteria: UsersSearchCriteria;
};

export type RemoveAccountInput = {
  /**   ID of account to remove */
  accountId: Scalars["String"];
  /**   Customer ID */
  customerId: Scalars["String"];
};

export type RemoveBackupPolicyInput = {
  customerId: Scalars["String"];
  policyId: Scalars["String"];
};

export type RemoveBackupSetupInput = {
  customerId: Scalars["String"];
  setupId: Scalars["String"];
};

export type RemoveDisasterRecoveryPlanInput = {
  customerId: Scalars["String"];
  planId: Scalars["String"];
};

export type RemoveNotificationGroupInput = {
  customerId: Scalars["String"];
  id: Scalars["String"];
};

export type RemoveTemplateInput = {
  customerId: Scalars["String"];
  templateId: Scalars["String"];
};

export type Report = {
  __typename?: "Report";
  /**   When the report was created */
  createdAt: Scalars["String"];
  /**   Report ID */
  id: Scalars["String"];
  /**   Status of report creation. */
  status: ReportCreationStatus;
  /**   The datetime when last time the status was updated. */
  updatedAt: Scalars["String"];
  /**   URL to download the report */
  url?: Maybe<Scalars["String"]>;
};

export enum ReportCreationStatus {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  Success = "SUCCESS",
}

export type ReportInput = {
  /**   Customer ID for which the report is asked */
  customerId: Scalars["String"];
  /**   Report date, e.g. for monthly reports put "2020-06" */
  reportDate: Scalars["String"];
  /**   Report type to fetch. */
  reportType: CustomerReportType;
};

/**  The Resource type represents a resource known by the Backup. */
export type Resource = {
  __typename?: "Resource";
  /**  ID of account generated by cloud provider. */
  accountCloudProviderId: Scalars["String"];
  /**  User friendly name of the account. */
  accountName: Scalars["String"];
  /**  A boolean flag indicating if the resource is backed up */
  backupEnabled: Scalars["Boolean"];
  /**  Backup policy defining retention and RPO applied to the resource. */
  backupPolicy?: Maybe<BackupPolicy>;
  /**  Backup setup defining additional resource settings. */
  backupSetup?: Maybe<BackupSetup>;
  /**
   *  User friendly name of applied backup setup.
   * @deprecated use backupSetup field
   */
  backupSetupName?: Maybe<Scalars["String"]>;
  /**  Resource category such as virtual host, database, storage, etc. */
  category: Scalars["String"];
  /**  Cloud provider from which the resource comes from. */
  cloudProvider: CloudProvider;
  /**  Field used to uniquely identify the resource. */
  id: Scalars["String"];
  /**  User friendly name of the resource. */
  name: Scalars["String"];
  /**   Resource size in bytes */
  sizeInBytes?: Maybe<Scalars["String"]>;
  /**  Resource type such as aws-ec2, aws-efs, etc. */
  type: Scalars["String"];
};

export type ResourceMapping = {
  __typename?: "ResourceMapping";
  parameter: Scalars["String"];
  resourceId: Scalars["String"];
};

export type ResourceMappingInput = {
  parameter: Scalars["String"];
  resourceId: Scalars["String"];
};

/**  The ResourceWithLastBackupStatus contains information about a resource and its last backup operation status. */
export type ResourceWithLastBackupStatus = {
  __typename?: "ResourceWithLastBackupStatus";
  /**
   *  Field containing information about status of the last finished backup operation performed on a resource
   * described by the resource field. The lastBackupStatus is empty when there are no completed backup operations
   * perfored on the resource.
   */
  lastBackupStatus?: Maybe<LastBackupStatus>;
  /**  Field containing information about a resource. */
  resource: Resource;
};

export type ResourcesPage = {
  __typename?: "ResourcesPage";
  data: Array<ResourceWithLastBackupStatus>;
  /**   Total number of pages with resources */
  totalNumberOfPages: Scalars["Int"];
  /**   Total number of resources */
  totalNumberOfResources: Scalars["Int"];
};

export type ResourcesSearchCriteria = {
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   List of filters */
  filters: Array<FilterInput>;
  /**   Page number */
  pageNumber?: InputMaybe<Scalars["Int"]>;
  /**   Show only removed resources */
  showRemoved?: InputMaybe<Scalars["Boolean"]>;
};

/**  The enumeration of supported retention conditions. */
export enum RetentionCondition {
  Quantity = "QUANTITY",
  TimeInDays = "TIME_IN_DAYS",
}

/**  The RetentionConfig type describes circumstances under which the backups should be removed. */
export type RetentionConfig = {
  __typename?: "RetentionConfig";
  /**
   *  Condition determines if the snapshot should be removed after desired number of days or
   * when there are more snapshots than a user has specified.
   */
  condition: RetentionCondition;
  /**  Threshold value related with a condition. It may describe a number of days or number of snapshots. */
  threshold: Scalars["Int"];
};

/**  The RetentionConfig type describes circumstances under which the backups should be removed. */
export type RetentionConfigInput = {
  /**
   *  Condition determines if the snapshot should be removed after desired number of days or
   * when there are more snapshots than a user has specified.
   */
  condition: RetentionCondition;
  /**  Threshold value related with a condition. It may describe a number of days or number of snapshots. */
  threshold: Scalars["Int"];
};

export type RevokeCustomerRoleFromApiKeyInput = {
  /**   Customer ID. */
  customerId: Scalars["ID"];
  /**   API key ID. */
  id: Scalars["String"];
  /**   Role to be removed for given customer. */
  role: UserRole;
};

export type RevokeCustomerRoleFromUserInput = {
  /**   Customer ID. */
  customerId: Scalars["ID"];
  /**   User email. */
  email: Scalars["String"];
  /**   Role to be removed for given customer. */
  role: UserRole;
};

/**   The scan statuses */
export enum ScanStatus {
  Done = "DONE",
  Error = "ERROR",
  Pending = "PENDING",
}

export type ScanStatusAccountInput = {
  accountId: Scalars["String"];
  customerId: Scalars["String"];
};

export type ScanStatusError = {
  __typename?: "ScanStatusError";
  /**   Account id for which there is an error */
  accountId: Scalars["String"];
  /**   Cloud provider id (e.g. AWS Account ID) */
  cloudProviderId: Scalars["String"];
  /**   The error message */
  message: Scalars["String"];
};

export type ScanStatusResult = {
  __typename?: "ScanStatusResult";
  /**   When the scan job was created */
  createdAt?: Maybe<Scalars["String"]>;
  /**  Optional field with error messages */
  errors?: Maybe<Array<ScanStatusError>>;
  /**   Scan job id */
  scanId: Scalars["String"];
  /**  Can be 'pending' | 'error' (there was an error when scanning one of the accounts) | 'done' (all accounts successfully scanned) */
  status: ScanStatus;
  /**   When the status of scan job was updated */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type ScanStatusUpdateInput = {
  /**   When the scan job was created */
  createdAt?: InputMaybe<Scalars["String"]>;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Scan job ID */
  scanId?: InputMaybe<Scalars["String"]>;
  /**  Can be 'pending' | 'error' (there was an error when scanning one of the accounts) | 'done' (all accounts successfully scanned) */
  status?: InputMaybe<ScanStatus>;
  /**   When the status of scan job was updated */
  updatedAt?: InputMaybe<Scalars["String"]>;
};

export type ScanStatusUpdateResult = {
  __typename?: "ScanStatusUpdateResult";
  /**   When the scan job was created */
  createdAt?: Maybe<Scalars["String"]>;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Scan job ID */
  scanId?: Maybe<Scalars["String"]>;
  /**  Can be 'pending' | 'error' (there was an error when scanning one of the accounts) | 'done' (all accounts successfully scanned) */
  status?: Maybe<ScanStatus>;
  /**   When the status of scan job was updated */
  updatedAt?: Maybe<Scalars["String"]>;
};

export type ScanTriggerResult = {
  __typename?: "ScanTriggerResult";
  /**   Identifier of the scanning job */
  scanId: Scalars["String"];
};

export type SelfCreateApiKeyInput = {
  alias: Scalars["String"];
};

/**   A pair of resource type and identifier of a setup which should be assigned to resources of specified type. */
export type SetupToResourceTypeAssignment = {
  /**   Type of resources. */
  resourceType: Scalars["String"];
  /**
   *   Identifier of a setup which should be assigned to resources of specified type.
   *  If omitted or equal to null, then backup setup will be detached from matched resources.
   *  This will also cause backup to be disabled for selected resources.
   */
  setupId?: InputMaybe<Scalars["String"]>;
};

export type SlackConfig = {
  __typename?: "SlackConfig";
  channelName: Scalars["String"];
  webHook: Scalars["String"];
};

export type SlackConfigInput = {
  channelName: Scalars["String"];
  webHook: Scalars["String"];
};

export type Snapshot = {
  __typename?: "Snapshot";
  accountId: Scalars["String"];
  creationTimestamp: Scalars["Int"];
  id: Scalars["String"];
  region: Scalars["String"];
  resourceId: Scalars["String"];
  /**   Blob containing information needed to restore resource from a snapshot */
  restoreData: Scalars["String"];
  type: SnapshotType;
};

export enum SnapshotType {
  Primary = "PRIMARY",
  Replica = "REPLICA",
}

/**  The SnapshotsRetention type describes how the backups should be retained. */
export type SnapshotsRetention = {
  __typename?: "SnapshotsRetention";
  /**  Describes retention of snapshots stored in the protected accounts. */
  primarySnapshotsRetention: RetentionConfig;
  /**  Describes retention of snapshots stored in the vault accounts. */
  replicaSnapshotsRetention: RetentionConfig;
};

/**  The SnapshotsRetention type describes how the backups should be retained. */
export type SnapshotsRetentionInput = {
  /**  Describes retention of snapshots stored in the protected accounts. */
  primarySnapshotsRetention: RetentionConfigInput;
  /**  Describes retention of snapshots stored in the vault accounts. */
  replicaSnapshotsRetention: RetentionConfigInput;
};

export type StartDisasterRecoveryInput = {
  assignee: Scalars["String"];
  customerId: Scalars["String"];
  /**
   *   The kmsKey is used by AutoBackup to copy encrypted AWS snapshots to restore region.
   *  Following formats are correct: key ID (for example, key/1234abcd-12ab-34cd-56ef-1234567890ab),
   *  key alias (for example, alias/ExampleAlias), key ARN (for example, arn:aws:kms:us-east-1:012345678910:key/abcd1234-a123-456a-a12b-a123b4cd56ef).
   */
  kmsKey?: InputMaybe<Scalars["String"]>;
  planId: Scalars["String"];
  /**   The date from snapshots should be restored (UNIX timestamp) */
  recoveryPointTimestamp: Scalars["Int"];
  restoreRegion: Scalars["String"];
};

/**   Static AWS Credentials */
export type StaticAwsCredentialsInput = {
  accessKeyId: Scalars["String"];
  secretAccessKey: Scalars["String"];
};

export type Subscription = {
  __typename?: "Subscription";
  exampleSubscription?: Maybe<Scalars["Boolean"]>;
  newMessage?: Maybe<Message>;
  scanStatusChanged?: Maybe<ScanStatusUpdateResult>;
};

export type SubscriptionNewMessageArgs = {
  customerId: Scalars["String"];
};

export type SubscriptionScanStatusChangedArgs = {
  customerId?: InputMaybe<Scalars["String"]>;
};

export type SuccessRateHistoryEntry = {
  __typename?: "SuccessRateHistoryEntry";
  backupEventId: Scalars["String"];
  numberOfResourcesMeetingRPO: Scalars["Int"];
  startTimestamp: Scalars["Int"];
  totalNumberOfResources: Scalars["Int"];
};

export type SummaryBackupsReport = {
  __typename?: "SummaryBackupsReport";
  numberOfAllBackupAttempts: Scalars["Int"];
  numberOfBackedUpResources: Scalars["Int"];
  numberOfSuccessfulBackups: Scalars["Int"];
};

export type SummaryBackupsReportScope = {
  customerId: Scalars["String"];
  timeRange: TimeRange;
};

export type Tag = {
  key: Scalars["String"];
  value: Scalars["String"];
};

export type Template = {
  __typename?: "Template";
  /**   Cloud provider */
  cloudProvider: CloudProvider;
  /**   Template Content */
  content: Scalars["String"];
  /**   Template ID */
  id: Scalars["String"];
  /**   Template Name */
  name: Scalars["String"];
  /**   Parameters */
  parameters?: Maybe<Array<Scalars["String"]>>;
};

export type TemplateLink = {
  __typename?: "TemplateLink";
  /**   Link to perform Disaster Recovery */
  link: Scalars["String"];
  /**   Template name */
  templateName: Scalars["String"];
};

export type TemplateResourcesMapping = {
  __typename?: "TemplateResourcesMapping";
  resourcesMapping?: Maybe<Array<ResourceMapping>>;
  template: Template;
};

export type TemplateResourcesMappingInput = {
  resourcesMapping?: InputMaybe<Array<ResourceMappingInput>>;
  templateId: Scalars["String"];
};

export type TemplateSearchCriteria = {
  /**   Customer ID for which the templates is asked */
  customerId: Scalars["String"];
  /**   Template ID */
  templateId: Scalars["String"];
};

export type TemplatesPage = {
  __typename?: "TemplatesPage";
  data: Array<Template>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfTemplates: Scalars["Int"];
};

export type TemplatesSearchCriteria = {
  /**   Template's cloud provider - optional filter. Returns only templates with specified cloud provider. */
  cloudProvider?: InputMaybe<CloudProvider>;
  /**   Customer ID for which the templates are asked */
  customerId: Scalars["String"];
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

/**  The Policy Settings type represents the schedule of retention settings */
export type TimeAwarePolicySettings = {
  __typename?: "TimeAwarePolicySettings";
  /**  The cron expression determines in what time intervals the backup has to execute. */
  cronExpression: Scalars["String"];
  /**  Backups retention settings. */
  retention: SnapshotsRetention;
  /**  The start date determines in what date the first backup has to begin. UNIX timestamp format. */
  startDateTimestamp?: Maybe<Scalars["Int"]>;
  /**  Backups window duration time setting. */
  timeWindowDuration: Scalars["Int"];
};

/**  The Policy Settings type represents the schedule of retention settings */
export type TimeAwarePolicySettingsInput = {
  /**  The cron expression determines in what time intervals the backup has to execute. */
  cronExpression: Scalars["String"];
  /**  Backups retention settings. */
  retention: SnapshotsRetentionInput;
  /**  The start date determines in what date the first backup has to begin. UNIX timestamp format. */
  startDateTimestamp?: InputMaybe<Scalars["Int"]>;
  /**  Backups window duration time setting. */
  timeWindowDuration: Scalars["Int"];
};

export type TimeRange = {
  dateFromTimestamp: Scalars["Int"];
  dateToTimestamp: Scalars["Int"];
};

/**   Trigger backup for a set of resources (given by 'resourceIDs') or resources selected by 'filters'. */
export type TriggerBackupInput = {
  /**   Customer ID from AutoBackup. */
  customerId: Scalars["String"];
  /**   Filters determine which resources will be backed up. */
  filters: Array<FilterInput>;
  /**
   *   Optional filter containing a list of resource identifiers for which the backup should be triggered.
   *  Note that triggering backup will affect only resources with matching identifiers AND matching criteria
   *  defined in filters field.
   */
  resourceIDs?: InputMaybe<Array<Scalars["String"]>>;
};

export type TriggerScanInput = {
  /**   Customer ID */
  customerId: Scalars["String"];
};

export type TriggerScanOnCloudAccountInput = {
  /**
   *   Account id for which the scan is triggered (format: <provider>__<customer_id>__<cloud provider id>)
   *  (example: AWS__d6327173181__01234567891)
   */
  accountId: Scalars["String"];
  customerId: Scalars["String"];
};

export type UpdateBackupSetupInput = {
  /**   List of backup settings */
  backupSettings: Array<BackupSettingInput>;
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Backup setup id */
  id: Scalars["String"];
  /**   Name of backup setup */
  name: Scalars["String"];
  /**   Posthook setup (optional) */
  postHook?: InputMaybe<HookInput>;
  /**   Prehook setup (optional) */
  preHook?: InputMaybe<HookInput>;
};

export type UpdateCustomerInput = {
  backupPoliciesBoundary: BackupPoliciesBoundaryInput;
  customerId: Scalars["String"];
  name: Scalars["String"];
};

export type UpdateDisasterRecoveryPlanInput = {
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Notification recipients */
  emails: Array<Scalars["String"]>;
  /**   Frequency of disaster recovery plan */
  frequencyInMonths: Scalars["Int"];
  /**   Plan ID */
  id: Scalars["String"];
  /**
   *   The kmsKey is used by AutoBackup to copy encrypted AWS snapshots to restore region.
   *  Following formats are correct: key ID (for example, key/1234abcd-12ab-34cd-56ef-1234567890ab),
   *  key alias (for example, alias/ExampleAlias), key ARN (for example, arn:aws:kms:us-east-1:012345678910:key/abcd1234-a123-456a-a12b-a123b4cd56ef).
   */
  kmsKey?: InputMaybe<Scalars["String"]>;
  /**   Plan name */
  name: Scalars["String"];
  /**   How many days before notification should be sent */
  remindDaysBefore: Scalars["Int"];
  /**   Region where DR testing should be performed (creating AMI, moving Snapshots). */
  restoreRegion: Scalars["String"];
  /**   Plan start date (UNIX timestamp) */
  startTimestamp: Scalars["Int"];
  /**   Attached templates */
  templatesResourcesMapping?: InputMaybe<Array<TemplateResourcesMappingInput>>;
};

export type UpdateDisasterRecoveryRecordInput = {
  customerId: Scalars["String"];
  id: Scalars["String"];
  /**
   *   Note field could be used by user to provide additional information about Disaster recovery, for example: error message,
   *  link to documents.
   */
  note: Scalars["String"];
  status: UpdateDisasterRecoveryStatus;
};

/**   Available status during updates of the disaster recovery record. */
export enum UpdateDisasterRecoveryStatus {
  Failed = "FAILED",
  Success = "SUCCESS",
}

export type UpdateTemplateInput = {
  /**   Template Content */
  content: Scalars["String"];
  /**   Customer ID */
  customerId: Scalars["String"];
  /**   Template ID */
  id: Scalars["String"];
  /**   Template Name */
  name: Scalars["String"];
};

export type User = {
  __typename?: "User";
  customerAccesses: CustomerAccessesPage;
  email: Scalars["String"];
  superAdmin: Scalars["Boolean"];
};

export type UserCustomerAccessesArgs = {
  searchCriteria?: InputMaybe<UserCustomerAccessesSearchCriteria>;
};

export type UserCustomerAccessesSearchCriteria = {
  /**   If no customer ID is provided, all customer accesses will be returned. */
  customerId?: InputMaybe<Scalars["ID"]>;
  /**   If no page number is provided, the first one will be returned. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type UserProfile = {
  __typename?: "UserProfile";
  bestAllowedPolicySettings: BestAllowedPolicySettings;
  companyName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  isBackupControlledByTags: Scalars["Boolean"];
  lastName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type UserProfileInput = {
  customerId: Scalars["String"];
  isBackupControlledByTags: Scalars["Boolean"];
};

/**  The UserRole is an enum listing roles supported by AutoBackup. */
export enum UserRole {
  Admin = "ADMIN",
  ReadOnly = "READ_ONLY",
  SuperAdmin = "SUPER_ADMIN",
}

export type UsersPage = {
  __typename?: "UsersPage";
  data: Array<User>;
  totalNumberOfPages: Scalars["Int"];
  totalNumberOfUsers: Scalars["Int"];
};

export type UsersSearchCriteria = {
  /**   If no page number is provided, the first one will be returned. */
  pageNumber?: InputMaybe<Scalars["Int"]>;
};

export type ValidateTemplateInput = {
  cloudProvider: CloudProvider;
  content: Scalars["String"];
};

export type ValidateTemplateResult = {
  __typename?: "ValidateTemplateResult";
  parameters: Array<Scalars["String"]>;
};

export type DisableCustomerMutationVariables = Exact<{
  input: DisableCustomerInput;
}>;

export type DisableCustomerMutation = {
  __typename?: "Mutation";
  disableCustomer: string;
};

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;

export type CreateCustomerMutation = {
  __typename?: "Mutation";
  createCustomer: { __typename?: "CustomerInfo"; id: string };
};

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;

export type UpdateCustomerMutation = {
  __typename?: "Mutation";
  updateCustomer: { __typename?: "CustomerInfo"; id: string };
};

export type GetCustomersQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomersQuery = {
  __typename?: "Query";
  customersList: Array<{
    __typename?: "CustomerBasic";
    id: string;
    name: string;
    backupPoliciesBoundary: {
      __typename?: "BackupPoliciesBoundary";
      minRPOInHours: number;
      maxPrimarySnapshotRetentionQuantity: number;
      maxPrimarySnapshotRetentionInDays: number;
      maxReplicaSnapshotRetentionQuantity: number;
      maxReplicaSnapshotRetentionInDays: number;
    };
  }>;
};

export const DisableCustomerDocument = gql`
  mutation disableCustomer($input: DisableCustomerInput!) {
    disableCustomer(input: $input)
  }
`;
export type DisableCustomerMutationFn = Apollo.MutationFunction<
  DisableCustomerMutation,
  DisableCustomerMutationVariables
>;

/**
 * __useDisableCustomerMutation__
 *
 * To run a mutation, you first call `useDisableCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableCustomerMutation, { data, loading, error }] = useDisableCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableCustomerMutation,
    DisableCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableCustomerMutation,
    DisableCustomerMutationVariables
  >(DisableCustomerDocument, options);
}
export type DisableCustomerMutationHookResult = ReturnType<
  typeof useDisableCustomerMutation
>;
export type DisableCustomerMutationResult =
  Apollo.MutationResult<DisableCustomerMutation>;
export type DisableCustomerMutationOptions = Apollo.BaseMutationOptions<
  DisableCustomerMutation,
  DisableCustomerMutationVariables
>;
export const CreateCustomerDocument = gql`
  mutation createCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      id
    }
  }
`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >(CreateCustomerDocument, options);
}
export type CreateCustomerMutationHookResult = ReturnType<
  typeof useCreateCustomerMutation
>;
export type CreateCustomerMutationResult =
  Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;
export const UpdateCustomerDocument = gql`
  mutation updateCustomer($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      id
    }
  }
`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UpdateCustomerDocument, options);
}
export type UpdateCustomerMutationHookResult = ReturnType<
  typeof useUpdateCustomerMutation
>;
export type UpdateCustomerMutationResult =
  Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export const GetCustomersDocument = gql`
  query getCustomers {
    customersList {
      id
      name
      backupPoliciesBoundary {
        minRPOInHours
        maxPrimarySnapshotRetentionQuantity
        maxPrimarySnapshotRetentionInDays
        maxReplicaSnapshotRetentionQuantity
        maxReplicaSnapshotRetentionInDays
      }
    }
  }
`;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCustomersQuery,
    GetCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(
    GetCustomersDocument,
    options
  );
}
export function useGetCustomersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomersQuery,
    GetCustomersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(
    GetCustomersDocument,
    options
  );
}
export type GetCustomersQueryHookResult = ReturnType<
  typeof useGetCustomersQuery
>;
export type GetCustomersLazyQueryHookResult = ReturnType<
  typeof useGetCustomersLazyQuery
>;
export type GetCustomersQueryResult = Apollo.QueryResult<
  GetCustomersQuery,
  GetCustomersQueryVariables
>;
